export default () => {
    return useCookie('refreshToken', {
        maxAge: 2592000, // 30 days
        secure: true,
    })
}
